import React, { ReactNode } from "react";
import {
  GoogleMap,
  withGoogleMap,
  GoogleMapProps,
  WithScriptjsProps
} from "react-google-maps";

interface Props extends WithScriptjsProps, GoogleMapProps {
  onMapMounted: (google: GoogleMap) => void;
  children?: ReactNode;
}

const GoogleMapsWrapper = withGoogleMap((props: Props) => (
  <GoogleMap {...props} ref={props.onMapMounted}>
    {props.children}
  </GoogleMap>
));

export default GoogleMapsWrapper;
